import React from 'react';
import {Row,Container,Col } from 'reactstrap';
import { withStyles } from '@material-ui/core/styles';
import LinearProgress from '@material-ui/core/LinearProgress';

export default class UploadingInfo extends React.Component {
    state = {
        canvasA: {
            canvasWidth: 100,
            canvasHeight: 100
        }
    }
    render() {
        const { file, isCompleted } = this.props;
        return (
            <Container className="grid-container display-type">
                <Row className="grid-item-wrapper" >
                    <Col >
                        {!isCompleted ? <ColorLinearProgress /> : null}
                    </Col>
                </Row>

            </Container>
        );
    }
}
const ColorLinearProgress = withStyles({
    colorPrimary: {
        backgroundColor: '#17a2b854',
    },
    barColorPrimary: {
        backgroundColor: '#17a2b8',
    },
})(LinearProgress);